<template>
  <div class="red-line">

  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .red-line{
    background-color: red;
    height: 20px;
    position: sticky;
    bottom: 0;
    z-index: 9999;
  }
</style>